import { Component } from '@angular/core';
import { SoftPopupComponent, TriggerSoftPopupDirective } from 'components/layout/soft-popup/soft-popup.component';
import { SummaryComponent } from 'components/layout/summary/summary.component';
import { DebugInputFieldsComponent } from 'components/test/debug-input-fields/debug-input-fields.component';
import { DraggableDirective } from 'directives/draggable.directive';
import { CredentialType } from 'enums/CredentialType';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { CurrencyPipe } from 'pipes/currency.pipe';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl } from 'services/navigation.service';

@Component({
	selector: 'debug-panel-layout',
	templateUrl: './debug-panel-layout.component.html',
	imports: [Layout, DraggableDirective, ListView, TriggerSoftPopupDirective, SoftPopupComponent, SummaryComponent, DebugInputFieldsComponent, CurrencyPipe, TranslatePipe, CustomDatePipe]
})
@ComponentUrl('debug-panel-layout')
@CredentialRequired(CredentialType.AccessDebugViews)
export class DebugPanelLayoutComponent {
	 
	posts = [{ f: 5 }, { f: 5 }, { f: 5 }, { f: 5 }, { f: 5 }];

	public codeTriggeredPopup = true;

	test(msg: string) {
		console.log(msg);
	}
} 
